<dmv-pub-language-select [languages]="languages" [selectedLanguage]="selectedLanguage" [route]="currentRoute$ | async">
</dmv-pub-language-select>